module.exports = __webpack_public_path__ + "img/indexIMG.c614a80b.png";